module.exports = __webpack_public_path__ + "img/CARACTE1.b3e20919.jpg";